/* global GOOGLE_CLIENT_ID */
import PropTypes from 'prop-types'
import React, { useState, useRef, useEffect } from 'react'
import { connect } from 'react-redux'
import { GoogleOAuthProvider, GoogleLogin } from '@react-oauth/google'
import { googleLoginCallbackDispatch as dispatchSelector } from 'reduxModules/auth/dispatchers'
import './styles.css'

// GIS button width is a fixed pixel value capped at 400 (no percentages), so to
// match the sibling Facebook/OpenAthens buttons at every viewport we track the
// wrapper's width (itself capped at 400px via CSS) and render the button at that
// size, updating on resize. Falls back to 400 before layout is measured.
const GIS_MAX_WIDTH = 400

// The GoogleOAuthProvider is wrapped inside the button so no app-root change is
// needed and the inCheckout login case works unchanged. onSuccess receives a
// CredentialResponse whose `credential` is the Google id_token JWT (D1); the
// dispatcher forwards it as { id_token }. onError is swallowed to match the
// other social buttons (a cancelled popup is not an app error).
export function GoogleSignIn({ googleLoginCallback }) {
  const wrapperRef = useRef(null)
  const [buttonWidth, setButtonWidth] = useState(GIS_MAX_WIDTH)

  useEffect(() => {
    const measure = () => {
      const el = wrapperRef.current
      if (el && el.offsetWidth)
        setButtonWidth(Math.min(GIS_MAX_WIDTH, Math.round(el.offsetWidth)))
    }
    measure()
    window.addEventListener('resize', measure)
    return () => window.removeEventListener('resize', measure)
  }, [])

  // Without a client id, Google Identity Services renders a broken button and
  // logs "client_id is not set correctly". Until GOOGLE_CLIENT_ID is configured
  // (the Google Cloud console ops step), render nothing rather than a broken
  // button.
  if (!GOOGLE_CLIENT_ID) return null

  return (
    <GoogleOAuthProvider clientId={GOOGLE_CLIENT_ID}>
      <div className="google-login-wrapper" ref={wrapperRef}>
        <GoogleLogin
          onSuccess={googleLoginCallback}
          onError={() => {}}
          theme="outline"
          size="large"
          shape="rectangular"
          text="continue_with"
          logo_alignment="left"
          width={String(buttonWidth)}
        />
      </div>
    </GoogleOAuthProvider>
  )
}

GoogleSignIn.propTypes = {
  googleLoginCallback: PropTypes.func.isRequired
}

export default connect(null, dispatchSelector)(GoogleSignIn)
